export default __webpack_public_path__ + "static/media/NH010.998d27a4.jpg";